export const CACHE_KEYS = {
  ORYXGO_CACHE_KEY: 'ORYXGO_cache',
  ORYXKS_CACHE_KEY: 'ORYXKS_cache',
  RECORDINGS_CACHE_KEY: 'saved_recordings',
  USERINFO_CACHE_KEY: 'userinfo_cache',
  MEASUREMENTSCOLLECTION_CACHE_KEY: 'measurements_collection_cache',
  REPORTINFODICT_CACHE_KEY: 'reportInfoDict',
};
